import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const EyeIcon: FC<IconProps> = memo(
  ({ fill = '#000', size, width, height }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(32);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        fill="none"
        width={width ?? size}
        height={height ?? size}
      >
        <Path
          d="M508 512m-112 0a112 112 0 1 0 224 0 112 112 0 1 0-224 0Z"
          fill={fill}
        />
        <Path
          d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3-7.7 16.2-7.7 35.2 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
          fill={fill}
        />
      </Svg>
    );
  },
);
